export let MicroappActionTypes;
(function (MicroappActionTypes) {
  MicroappActionTypes["UpdateMicroapp"] = "[Microapp] Update Microapp";
})(MicroappActionTypes || (MicroappActionTypes = {}));